'use strict';

var React = require('react');

var SvgCartUpMajor = function SvgCartUpMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.414v3.586a1 1 0 1 0 2 0v-3.586l1.293 1.293a1 1 0 1 0 1.414-1.414l-3-3a.998.998 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414l1.293-1.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 1a1 1 0 0 1 1-1h1.5a1.5 1.5 0 0 1 1.5 1.5v8.5h11.133l.877-6.141a1 1 0 1 1 1.98.282l-.939 6.571a1.5 1.5 0 0 1-1.485 1.288h-11.566v2h10a3 3 0 1 1-2.83 2h-5.34a3 3 0 1 1-3.83-1.83v-12.17h-1a1 1 0 0 1-1-1zm13 16a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-11 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0z"
  }));
};

exports.SvgCartUpMajor = SvgCartUpMajor;
